<template>
  <div class="FloatingWindow clear">
    <!-- <a href="http://wpa.qq.com/msgrd?v=3&uin=10001&site=qq&menu=yes" class="FloatingWindow_list fr" target="_blank">
		<div class="FloatingWindow_list_title">
			<dd class="iconfont">&#xe675;</dd>
			<dt>在线咨询</dt>
		</div>
	</a> 
    <a href="http://wpa.qq.com/msgrd?v=3&uin=10001&site=qq&menu=yes" class="FloatingWindow_list fr" target="_blank">
		<div class="FloatingWindow_list_title">
			<dd class="iconfont">&#xe618;</dd>
			<dt>QQ咨询</dt>
		</div>
	</a>
	<a href="javascript:;" class="FloatingWindow_list fr">
		<div class="FloatingWindow_list_title">
			<dd class="iconfont">&#xe619;</dd>
			<dt>服务热线</dt>
		</div>
		<div class="FloatingWindow_list_down bounceInRight animated">服务热线：010-12345678</div>
	</a> -->
    <a
      href="javascript:;"
      class="FloatingWindow_list fr"
      id="top"
      @click="handleScrollTop"
    >
      <div class="FloatingWindow_list_title">
        <!-- <dd class="iconfont">&#xe628;</dd> -->
        <dd class="iconfont">
          <i class="iconfont icon-xiangshangjiantou"></i>
        </dd>
        <dt>TOP</dt>
      </div>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
const handleScrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
onMounted(() => {});
</script>
<style lang="scss" scoped></style>
